import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManageCityComponent from '../../components/ManageCityComponent/ManageCityComponent'

const ManageCity = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageCityComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManageCity
